import React from "react";
import { FiSettings } from "react-icons/fi";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Cookies() {
  const sections = [
    ["cookie-overview", "Overview"],
    ["cookie-types", "Cookie types"],
    ["cookie-controls", "Your choices"],
    ["cookie-retention", "Retention"],
    ["cookie-contact", "Contact"],
  ];

  return (
    <main className="privacy-page">
      <header className="privacy-page__hero">
        <FiSettings aria-hidden="true" />
        <p>Legal</p>
        <h1>Cookie policy</h1>
        <span>Last updated 16 September 2026</span>
      </header>
      <div className="privacy-page__layout">
        <aside aria-label="Cookie policy contents"><p>On this page</p><nav>{sections.map(([id, label], index) => <a href={`#${id}`} key={id}><span>{String(index + 1).padStart(2, "0")}</span>{label}</a>)}</nav></aside>
        <article>
          <section id="cookie-overview"><p className="privacy-page__section-number">01</p><h2>Overview</h2><p>Cookies and similar browser storage help this storefront work, keep your shopping bag available and remember choices. This policy explains the categories we may use.</p><p>For information about personal data, read our <Link to="/privacy">privacy policy</Link>.</p></section>
          <section id="cookie-types"><p className="privacy-page__section-number">02</p><h2>Cookie types</h2><ul><li><strong>Essential:</strong> security, checkout, navigation and shopping-bag functions.</li><li><strong>Preferences:</strong> language, region and display choices.</li><li><strong>Analytics:</strong> aggregated information that helps us understand storefront performance.</li><li><strong>Marketing:</strong> measurement or personalisation used only where permitted and selected.</li></ul></section>
          <section id="cookie-controls"><p className="privacy-page__section-number">03</p><h2>Your choices</h2><p>You can block or remove cookies in your browser settings. Essential storage cannot always be disabled without affecting checkout, saved bag items or site security.</p><p>Where the site offers a consent control, you can revisit it to change optional categories without affecting earlier lawful use.</p></section>
          <section id="cookie-retention"><p className="privacy-page__section-number">04</p><h2>Retention</h2><p>Session cookies expire when the browser closes. Persistent cookies remain only for the stated operational or preference period, unless you remove them sooner through your browser.</p></section>
          <section id="cookie-contact" className="privacy-page__contact"><p className="privacy-page__section-number">05</p><h2>Questions about cookies?</h2><p>Contact customer care and mark your message “Cookie policy”.</p><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><span>{siteConfig.legalName}</span><span>{siteConfig.contact.location}</span></section>
        </article>
      </div>
    </main>
  );
}

export default Cookies;
